// Ported verbatim from ops-portal/src/app_config.json.
// Env-independent constants: backend path prefixes, regex validators, idle timeouts, MIME map.
export const appConfig = {
  airtableApi: '/api/v1/airtable',
  operationsApi: '/api/v1/operations',
  useroperationApi: '/api/v1/useroperation',
  identityVerificationApi: '/api/v1/identityVerification',
  shopsManagementApi: '/api/v1/shops',
  adminApi: 'api/v1/admin',
  userAccountApi: '/api/v1/useraccount',
  signupApi: '/api/v1/register',
  googleMapKey: 'AIzaSyDCL69m6oWwhEZ0ZyTjtAdn2gdF5wPlmwU',
  passwordPattern: '^(?=.*\\d)(?=.*[a-z])(?=.*[A-Z])(?!.*\\s).*$',
  phonePatternValidator: '^((\\+237-?)|0)?[0-9]{3}-[0-9]{3} [0-9]{3}$',
  timeoutInactivity: 1800,
  remainingTime: 60,
  defaultLanguage: 'en',
  extToMimes: {
    pdf: 'application/pdf',
    bmp: 'image/bmp',
    doc: 'application/msword',
    gif: 'image/gif',
    html: 'text/html',
    jpg: 'image/jpeg',
    jpeg: 'image/jpeg',
    jfif: 'image/jpeg',
    pjpg: 'image/jpeg',
    jif: 'image/jpeg',
    png: 'image/png',
    ppt: 'application/vnd.ms-powerpoint',
    svg: 'image/svg+xml',
  },
} as const;

export type AppConfig = typeof appConfig;
